/* Inventory: stock on hand, stock counts, transfers, and usage & variance.
 * Shared vocabulary (actions, statuses, table basics) lives in common.js. */
const inventory = {
  // --- Shared across inventory screens --------------------------------------
  'Not allowed': 'Tidak diizinkan',
  'Not found.': 'Tidak ditemukan.',
  'Try adjusting your search or filters.': 'Coba sesuaikan pencarian atau filter Anda.',
  'Posted': 'Diposting',
  'Posted by': 'Diposting oleh',
  'Posted at': 'Diposting pada',
  'Created at': 'Dibuat pada',
  'Value': 'Nilai',
  'Unit cost': 'Biaya satuan',
  'Variance': 'Selisih',
  'On hand': 'Tersedia',
  'Locations': 'Lokasi',
  'All locations': 'Semua lokasi',
  'Select a location…': 'Pilih lokasi…',
  'Cancel & reverse': 'Batalkan & balikkan',
  'Discard draft': 'Buang draf',
  'Reason (optional)': 'Alasan (opsional)',
  'by {name}': 'oleh {name}',
  'on {date}': 'pada {date}',
  'Reason: {reason}': 'Alasan: {reason}',

  // --- Stock on hand ---------------------------------------------------------
  'Live on-hand balances per item and location, valued at moving-average cost. Updated automatically as goods are received.':
    'Saldo stok tersedia per barang dan lokasi secara langsung, dinilai dengan biaya rata-rata bergerak. Diperbarui otomatis saat barang diterima.',
  'Failed to load stock.': 'Gagal memuat stok.',
  "Couldn't load stock": 'Tidak dapat memuat stok',
  'Stock lines': 'Baris stok',
  'Value (this page)': 'Nilai (halaman ini)',
  'Search by item or SKU…': 'Cari berdasarkan barang atau SKU…',
  'Zero stock': 'Stok nol',
  'Include': 'Sertakan',
  'Hide zero balances': 'Sembunyikan saldo nol',
  'Avg cost': 'Biaya rata-rata',
  'Stock value': 'Nilai stok',
  'Last movement': 'Pergerakan terakhir',
  'No matching stock': 'Tidak ada stok yang cocok',
  'No stock on hand yet': 'Belum ada stok tersedia',
  'Stock balances build up automatically as you receive goods against purchase orders.':
    'Saldo stok terbentuk otomatis saat Anda menerima barang dari pesanan pembelian.',

  // --- Stock counts ----------------------------------------------------------
  'Stock counts': 'Penghitungan stok',
  'Count': 'Penghitungan',
  'Counted': 'Dihitung',
  'Count date': 'Tanggal penghitungan',
  'Count type': 'Tipe penghitungan',
  'Full count': 'Penghitungan penuh',
  'Cycle count': 'Penghitungan siklus',
  "Physical and cycle counts. Open a count sheet for a location, record what's physically on hand, then post the variances to the inventory ledger.":
    'Penghitungan fisik dan siklus. Buka lembar penghitungan untuk sebuah lokasi, catat stok fisik yang ada, lalu posting selisihnya ke buku besar inventaris.',
  'Failed to load counts.': 'Gagal memuat penghitungan.',
  "Couldn't load counts": 'Tidak dapat memuat penghitungan',
  'New count': 'Penghitungan baru',
  'Search by count number or notes…': 'Cari berdasarkan nomor penghitungan atau catatan…',
  'No matching counts': 'Tidak ada penghitungan yang cocok',
  'No stock counts yet': 'Belum ada penghitungan stok',
  'Start a count to reconcile physical stock against the system on-hand balances.':
    'Mulai penghitungan untuk merekonsiliasi stok fisik dengan saldo stok tersedia di sistem.',
  'New stock count': 'Penghitungan stok baru',
  'Open a count sheet for one location. The current on-hand of every item in scope is snapshotted so you can record the physical counts against it.':
    'Buka lembar penghitungan untuk satu lokasi. Stok tersedia saat ini dari setiap barang dalam cakupan direkam sehingga Anda dapat mencatat hasil hitung fisik terhadapnya.',
  'No stock locations exist yet. Create a location in Settings before starting a count.':
    'Belum ada lokasi stok. Buat lokasi di Pengaturan sebelum memulai penghitungan.',
  'Choose a location to count': 'Pilih lokasi untuk dihitung',
  'Include items with zero on-hand': 'Sertakan barang dengan stok nol',
  'Useful for a full count so missing items can be reconciled; uncheck to count only items that currently show stock.':
    'Berguna untuk penghitungan penuh agar barang yang hilang dapat direkonsiliasi; hapus centang untuk menghitung hanya barang yang saat ini menunjukkan stok.',
  'Optional — e.g. month-end count, area, counter name': 'Opsional — mis. penghitungan akhir bulan, area, nama penghitung',
  'Create count sheet': 'Buat lembar penghitungan',
  'Count sheet created — record your counts': 'Lembar penghitungan dibuat — catat hasil hitung Anda',
  'Could not create count': 'Tidak dapat membuat penghitungan',
  "You don't have permission to perform stock counts.": 'Anda tidak memiliki izin untuk melakukan penghitungan stok.',
  'Count not found.': 'Penghitungan tidak ditemukan.',
  "Couldn't load count": 'Tidak dapat memuat penghitungan',
  'Back to counts': 'Kembali ke penghitungan',
  'Draft count': 'Draf penghitungan',
  'Count {number}': 'Penghitungan {number}',
  'Counts saved': 'Hasil hitung tersimpan',
  'Could not save counts': 'Tidak dapat menyimpan hasil hitung',
  'Count {number} posted': 'Penghitungan {number} diposting',
  'Could not post count': 'Tidak dapat memposting penghitungan',
  'Count cancelled and reversed': 'Penghitungan dibatalkan dan dibalikkan',
  'Draft count discarded': 'Draf penghitungan dibuang',
  'Could not cancel count': 'Tidak dapat membatalkan penghitungan',
  'Post count': 'Posting penghitungan',
  'This count is a draft — record the physical quantities, then post to apply the variances. On-hand balances are only changed when you post.':
    'Penghitungan ini masih draf — catat kuantitas fisik, lalu posting untuk menerapkan selisihnya. Saldo stok tersedia hanya berubah saat Anda memposting.',
  'This count was cancelled': 'Penghitungan ini dibatalkan',
  'Items in scope': 'Barang dalam cakupan',
  'Net variance': 'Selisih bersih',
  'Shrinkage': 'Penyusutan',
  'Count sheet': 'Lembar penghitungan',
  'Enter the physical count for each item. Leave blank to skip an item (no adjustment).':
    'Masukkan hasil hitung fisik untuk setiap barang. Biarkan kosong untuk melewati barang (tanpa penyesuaian).',
  'Variances posted to the inventory ledger; on-hand was reset to the counted figures.':
    'Selisih telah diposting ke buku besar inventaris; stok tersedia disetel ulang ke angka hasil hitung.',
  'Fill blanks with system qty': 'Isi yang kosong dengan kts sistem',
  'No items in scope': 'Tidak ada barang dalam cakupan',
  'This count has no lines.': 'Penghitungan ini tidak memiliki baris.',
  'System': 'Sistem',
  'Variance value': 'Nilai selisih',
  'not counted': 'belum dihitung',
  'Posting writes each variance to the inventory ledger and resets on-hand to the counted figures. Uncounted items are left unchanged. You can still reverse it afterwards.':
    'Memposting menulis setiap selisih ke buku besar inventaris dan menyetel ulang stok tersedia ke angka hasil hitung. Barang yang belum dihitung tidak diubah. Anda masih dapat membalikkannya setelahnya.',
  'Cancel & reverse count': 'Batalkan & balikkan penghitungan',
  'Discard draft count': 'Buang draf penghitungan',
  'This reverses the posted variance movements and restores the prior on-hand balances.':
    'Ini membalikkan pergerakan selisih yang telah diposting dan memulihkan saldo stok tersedia sebelumnya.',
  'This voids the draft count. Nothing has been committed, so there is nothing to reverse.':
    'Ini membatalkan draf penghitungan. Belum ada yang diterapkan, jadi tidak ada yang perlu dibalikkan.',
  'Cancel count': 'Batalkan penghitungan',

  // --- Transfers ---------------------------------------------------------------
  'Transfer': 'Transfer',
  'Transfer date': 'Tanggal transfer',
  'From → To': 'Dari → Ke',
  "Move stock between locations. Posting a transfer carries the value at the source's moving-average cost and updates on-hand at both ends.":
    'Pindahkan stok antar lokasi. Memposting transfer membawa nilai pada biaya rata-rata bergerak lokasi asal dan memperbarui stok tersedia di kedua sisi.',
  'Failed to load transfers.': 'Gagal memuat transfer.',
  "Couldn't load transfers": 'Tidak dapat memuat transfer',
  'New transfer': 'Transfer baru',
  'Search by transfer number or notes…': 'Cari berdasarkan nomor transfer atau catatan…',
  'No matching transfers': 'Tidak ada transfer yang cocok',
  'No transfers yet': 'Belum ada transfer',
  'Move stock between two locations — the value follows at moving-average cost.':
    'Pindahkan stok antara dua lokasi — nilainya mengikuti biaya rata-rata bergerak.',
  'Move stock from one location to another. Pick the source and destination, then choose how much of each item to send.':
    'Pindahkan stok dari satu lokasi ke lokasi lain. Pilih asal dan tujuan, lalu tentukan berapa banyak setiap barang yang dikirim.',
  'At least two stock locations are needed to transfer between them. Add locations in Settings first.':
    'Dibutuhkan minimal dua lokasi stok untuk melakukan transfer. Tambahkan lokasi di Pengaturan terlebih dahulu.',
  'From location': 'Lokasi asal',
  'To location': 'Lokasi tujuan',
  'Choose a source location': 'Pilih lokasi asal',
  "Pick where the stock is moving from to see what's available.": 'Pilih dari mana stok akan dipindahkan untuk melihat apa yang tersedia.',
  'Items to move': 'Barang yang dipindahkan',
  "Enter a quantity for each item you want to send. You can't transfer more than what's on hand at the source.":
    'Masukkan kuantitas untuk setiap barang yang ingin Anda kirim. Anda tidak dapat mentransfer lebih dari stok tersedia di lokasi asal.',
  'No stock at this location': 'Tidak ada stok di lokasi ini',
  'The source location has no on-hand stock to transfer.': 'Lokasi asal tidak memiliki stok tersedia untuk ditransfer.',
  'Search items…': 'Cari barang…',
  '{quantity} on hand': '{quantity} tersedia',
  'No items match “{search}”.': 'Tidak ada barang yang cocok dengan “{search}”.',
  'Optional — reason for the transfer': 'Opsional — alasan transfer',
  'destination': 'tujuan',
  '{count} item': '{count} barang',
  '{count} items': '{count} barang',
  'Post transfer': 'Posting transfer',
  'Save as draft': 'Simpan sebagai draf',
  'Choose both a source and destination location': 'Pilih lokasi asal dan tujuan',
  'Cannot transfer more {item} than the {quantity} on hand': 'Tidak dapat mentransfer {item} melebihi {quantity} yang tersedia',
  'Enter a quantity for at least one item': 'Masukkan kuantitas untuk minimal satu barang',
  'Transfer {number} posted': 'Transfer {number} diposting',
  'Draft transfer saved': 'Draf transfer tersimpan',
  'Could not create transfer': 'Tidak dapat membuat transfer',
  "You don't have permission to transfer stock.": 'Anda tidak memiliki izin untuk mentransfer stok.',
  'Transfer not found.': 'Transfer tidak ditemukan.',
  "Couldn't load transfer": 'Tidak dapat memuat transfer',
  'Back to transfers': 'Kembali ke transfer',
  'Draft transfer': 'Draf transfer',
  'Transfer {number}': 'Transfer {number}',
  'Could not post transfer': 'Tidak dapat memposting transfer',
  'Transfer cancelled and reversed': 'Transfer dibatalkan dan dibalikkan',
  'Draft transfer discarded': 'Draf transfer dibuang',
  'Could not cancel transfer': 'Tidak dapat membatalkan transfer',
  'Route': 'Rute',
  'This transfer is a draft — no stock has moved yet. Post it to move the items and update on-hand at both locations.':
    'Transfer ini masih draf — belum ada stok yang berpindah. Posting untuk memindahkan barang dan memperbarui stok tersedia di kedua lokasi.',
  'This transfer was cancelled': 'Transfer ini dibatalkan',
  'Transfer value': 'Nilai transfer',
  'These quantities were moved from the source to the destination.': 'Kuantitas ini telah dipindahkan dari lokasi asal ke tujuan.',
  'These quantities will move when the transfer is posted.': 'Kuantitas ini akan berpindah saat transfer diposting.',
  "Posting moves the items out of the source location and into the destination, carrying value at the source's moving-average cost. You can still reverse it afterwards.":
    'Memposting memindahkan barang keluar dari lokasi asal ke tujuan, membawa nilai pada biaya rata-rata bergerak lokasi asal. Anda masih dapat membalikkannya setelahnya.',
  'Cancel & reverse transfer': 'Batalkan & balikkan transfer',
  'Discard draft transfer': 'Buang draf transfer',
  'This sends the items back to the source location and restores both on-hand balances. It only works if the destination still holds the transferred stock.':
    'Ini mengembalikan barang ke lokasi asal dan memulihkan kedua saldo stok tersedia. Hanya berfungsi jika lokasi tujuan masih menyimpan stok yang ditransfer.',
  'This voids the draft transfer. Nothing has been committed, so there is nothing to reverse.':
    'Ini membatalkan draf transfer. Belum ada yang diterapkan, jadi tidak ada yang perlu dibalikkan.',
  'Cancel transfer': 'Batalkan transfer',

  // --- Usage & variance --------------------------------------------------------
  'Usage & variance': 'Pemakaian & selisih',
  'Compare theoretical ingredient usage (from sales × recipes) against actual usage (from the inventory ledger) to surface over-portioning, waste and shrink.':
    'Bandingkan pemakaian bahan teoretis (dari penjualan × resep) dengan pemakaian aktual (dari buku besar inventaris) untuk mengungkap porsi berlebih, pemborosan, dan penyusutan.',
  'New analysis': 'Analisis baru',
  'Ref': 'Ref',
  'Analysis': 'Analisis',
  'Theoretical': 'Teoretis',
  'Actual': 'Aktual',
  'Flagged': 'Ditandai',
  'No usage analyses yet': 'Belum ada analisis pemakaian',
  "Pick a period, enter the menu items sold, and we'll compare expected vs actual ingredient usage to find where food cost is leaking.":
    'Pilih periode, masukkan item menu yang terjual, dan kami akan membandingkan pemakaian bahan yang diharapkan dengan yang aktual untuk menemukan di mana biaya makanan bocor.',
  'Usage analysis': 'Analisis pemakaian',
  'New usage analysis': 'Analisis pemakaian baru',
  'Theoretical usage is exploded from the menu items sold; actual usage comes from the inventory ledger over the period. The variance shows where food cost is leaking.':
    'Pemakaian teoretis diurai dari item menu yang terjual; pemakaian aktual berasal dari buku besar inventaris selama periode tersebut. Selisihnya menunjukkan di mana biaya makanan bocor.',
  'Could not load analysis': 'Tidak dapat memuat analisis',
  'Create analysis': 'Buat analisis',
  'Enter a name for the analysis.': 'Masukkan nama untuk analisis.',
  'Set the period start and end dates.': 'Atur tanggal mulai dan akhir periode.',
  'Add at least one menu item sold.': 'Tambahkan minimal satu item menu yang terjual.',
  'Analysis saved': 'Analisis tersimpan',
  '{number} created': '{number} dibuat',
  'Could not save analysis': 'Tidak dapat menyimpan analisis',
  'Analysis deleted': 'Analisis dihapus',
  'Could not delete analysis': 'Tidak dapat menghapus analisis',
  'Delete analysis': 'Hapus analisis',
  'This permanently removes the usage/variance analysis.': 'Ini menghapus analisis pemakaian/selisih secara permanen.',
  'e.g. Kitchen — week 23': 'mis. Dapur — minggu 23',
  'Period start': 'Awal periode',
  'Period end': 'Akhir periode',
  'Location scope': 'Cakupan lokasi',
  'Flag threshold %': 'Ambang penandaan %',
  'Flag items above this variance': 'Tandai barang di atas selisih ini',
  'Context for this study (optional)': 'Konteks untuk kajian ini (opsional)',
  'Menu items sold': 'Item menu terjual',
  'Updating…': 'Memperbarui…',
  'Import sales': 'Impor penjualan',
  'Add a menu item…': 'Tambah item menu…',
  'Search menu items…': 'Cari item menu…',
  'No menu items — create some in Recipes first': 'Tidak ada item menu — buat dahulu di Resep',
  'All menu items added': 'Semua item menu sudah ditambahkan',
  'Add menu item': 'Tambah item menu',
  'Add the menu items sold during the period (or use Import sales). Theoretical ingredient usage is exploded from each recipe.':
    'Tambahkan item menu yang terjual selama periode ini (atau gunakan Impor penjualan). Pemakaian bahan teoretis diurai dari setiap resep.',
  'Units sold': 'Unit terjual',
  'Imported {count} line': 'Mengimpor {count} baris',
  'Imported {count} lines': 'Mengimpor {count} baris',
  '{count} unmatched': '{count} tidak cocok',
  'No rows matched a menu item by name or reference.': 'Tidak ada baris yang cocok dengan item menu berdasarkan nama atau referensi.',
  'Paste rows from your POS as “Menu item, units sold” (comma, tab or semicolon separated). Items are matched by name or reference.':
    'Tempel baris dari POS Anda dalam format “Item menu, unit terjual” (dipisahkan koma, tab, atau titik koma). Item dicocokkan berdasarkan nama atau referensi.',
  'Sales rows': 'Baris penjualan',
  'Food-cost variance': 'Selisih biaya makanan',
  'Set the period dates to compute actual usage from the inventory ledger.': 'Atur tanggal periode untuk menghitung pemakaian aktual dari buku besar inventaris.',
  'Add menu items sold to compute the variance.': 'Tambahkan item menu terjual untuk menghitung selisihnya.',
  'Theoretical cost': 'Biaya teoretis',
  'Actual cost': 'Biaya aktual',
  'Total variance': 'Total selisih',
  '{count} menu items': '{count} item menu',
  '{count} ledger moves': '{count} pergerakan buku besar',
  '{percent}% vs theoretical': '{percent}% vs teoretis',
  'Flagged {count}': 'Ditandai {count}',
  'Over {count}': 'Lebih {count}',
  'Under {count}': 'Kurang {count}',
  'Positive variance = used more than the recipes predict (over-portioning, waste or shrink). Both sides are valued at current item cost.':
    'Selisih positif = pemakaian lebih banyak dari perkiraan resep (porsi berlebih, pemborosan, atau penyusutan). Kedua sisi dinilai pada biaya barang saat ini.',
  'Item variance': 'Selisih per barang',
  'Largest unfavorable variance first': 'Selisih tidak menguntungkan terbesar lebih dulu',
  'flag': 'tanda',
  'no cost': 'tanpa biaya',
  'Theo qty': 'Kts teoretis',
  'Actual qty': 'Kts aktual',
  'Var qty': 'Kts selisih',
  'Theo cost': 'Biaya teoretis',
};

export default inventory;
